// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ke1z","colMin":"styles_colMin__38-qU"};